import { render, staticRenderFns } from "./team-insights-payment-detail.vue?vue&type=template&id=39744e24&"
import script from "./team-insights-payment-detail.ts?vue&type=script&lang=js&"
export * from "./team-insights-payment-detail.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports